const types = {
	currency_exchange: 'currency_exchange',
	transfer_money_between_affiliates: 'transfer_money_between_affiliates',
	transfer_money: 'transfer_money',
	transfer_prize_money: 'transfer_prize_money',
	transfer_promo_code_money: 'transfer_promo_code_money',
	transfer_adjustment_money: 'transfer_adjustment_money',
	points_exchange: 'points_exchange',
	transfer_hidden_money: 'transfer_hidden_money'
};

const enTranslation = {
	currency_exchange: 'Currency exchange',
	transfer_money_between_affiliates: 'Transfer money between affiliates',
	transfer_money: 'Transfer money',
	transfer_promo_code_money: 'Transfer promo_code money',
	transfer_prize_money: 'Transfer money - Presents and prizes',
	transfer_adjustment_money: 'Transfer money - Manual adjustments',
	points_exchange: 'Points exchange to money',
	transfer_hidden_money: 'Transfer hidden money'
};

const locale = {
	ru: enTranslation,
	uk: enTranslation,
	en: enTranslation,
	de: enTranslation,
	vi: enTranslation,
	th: enTranslation
};

module.exports = {
	enum: types,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/admin-transaction-types.js